export default __webpack_public_path__ + "static/media/dg_shipping_logo_new.9a05ca1d.png";